import styled from 'styled-components';
import { rem } from 'polished';
import selectArrowIcon from '../../assets/select-arrow.svg';

const DateWrapper = styled.div`
  position: relative;
  .DateRangePickerInput__withBorder {
    align-items: center;
    display: flex;
    border-radius: ${({ theme }) => theme.borderRadius};
    padding-right: ${rem(32)};
    background-image: url(${selectArrowIcon});
    background-repeat: no-repeat;
    background-position: center right;
  }
  .SingleDatePickerInput__withBorder {
    border: none;
    width: 100%;
    align-items: center;
    display: flex;
    background-image: url(${selectArrowIcon});
    background-repeat: no-repeat;
    background-position: center right;
  }
  .DateInput {
    background: transparent;
  }
  .DateInput_input,
  .DateInput,
  .gyPFjX .SingleDatePickerInput__withBorder,
  .SingleDatePickerInput__withBorder {
    border-radius: ${({ theme }) => theme.borderRadius};
  }
  .DateInput_input {
    background: transparent;
    font-size: ${rem(14)};
    border-bottom: none;
    height: ${rem(52)};
    width: 100%;
    font-size: 0.875rem;
    outline: 0;
    height: 3.25rem;
    border: none;
    -webkit-appearance: none;
    text-align: center;
    padding: 0 ${rem(10)};
    font-family: 'Roboto', sans-serif;
    color: ${({ theme }) => theme.color.font.primary};
  }
  .SingleDatePicker {
    width: 100%;
  }
  .SingleDatePicker_picker {
    z-index: 10;
  }
  .DateInput {
    width: 100%;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${({ theme }) => theme.color.primary};
    border: ${rem(1)} solid ${({ theme }) => theme.color.primary};
  }
  .DayPickerKeyboardShortcuts_show__bottomRight {
    display: none;
  }
  .DateInput_input__focused {
    border-bottom: none;
  }
  .DateRangePickerInput__withBorder {
    border: none;
  }
  .CalendarDay__selected_span,
  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover,
  .CalendarDay__hovered_span,
  .CalendarDay__hovered_span:hover {
    background: #ef6984;
    border: ${rem(1)} solid #ef6984;
    color: white;
  }
  .CalendarDay__last_in_range {
  }
  .DateRangePicker {
    width: 100%;
  }
`;

export default DateWrapper;



// WEBPACK FOOTER //
// ./src/containers/ConnectionForm/DateWrapper.js